import SolutionCard from "../../reusables/SolutionCard";
import app from "../../../assets/images/solutions-icon/mobile_app.svg";

const AppSolution = () => {
  return (
    <SolutionCard
      icon={app}
      title="Mobile App Development"
      subtitle="Android and iOS apps designed for usability and performance"
      ctaLink="/solutions/mobile-apps-development"
    />
  );
};
 
export default AppSolution;